import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

const StatusBar = ({ status, showBackOnline, onRetry, onClose }) => {
  const open = !!status || showBackOnline;
  let message = '';
  let severity = 'error';

  // Determine message and severity
  if (showBackOnline) {
    message = 'Back Online';
    severity = 'success';
  } else if (status) {
    message = status.message;
    severity = status.type === 'maintenance' ? 'warning' : 'error';
  }

  // Auto-hide after 3 seconds when status is maintenance or back online.
  const autoHideDuration = (status?.type === 'maintenance' || showBackOnline) ? 3000 : null;
  // Only show actions if not in maintenance or back online mode.
  const showActions = !(status?.type === 'maintenance' || showBackOnline);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      sx={{ bottom: 16, zIndex: (theme) => theme.zIndex.snackbar + 1 }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        action={
          showActions && (
            <>
              {onRetry && (
                <Button color="inherit" size="small" onClick={onRetry}>
                  Retry
                </Button>
              )}
              {onClose && (
                <Button color="inherit" size="small" onClick={onClose}>
                  Close
                </Button>
              )}
            </>
          )
        }
        sx={{
          width: '100%',
          boxShadow: '0px -2px 10px rgba(0,0,0,0.2)',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default StatusBar;
